var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavbarStick',{on:{"toggleMenu":_vm.openDrawer}}),_c('router-view',{on:{"toggleMenu":_vm.openDrawer}}),_c('FooterComp'),_c('DrawerMenu',{attrs:{"showDrawer":_vm.showDrawer},on:{"closeDrawer":_vm.closeDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }